import { createStore, applyMiddleware, compose } from 'redux'
import Middlewares from '../middlewares'
import reducer from '../reducers'

let composeEnhancers = compose

// Only expose the store object to the redux tools in case of dev builds
if (process.env.NODE_ENV === 'development') {
    /* eslint-disable no-underscore-dangle */
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    /* eslint-enable */
}

const store = createStore(reducer, composeEnhancers(applyMiddleware(...Middlewares)))

export default store



// WEBPACK FOOTER //
// ./src/store/index.js